const { getElement } = window.BAO.Utils

class HeaderSubnav extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.handleToggleButtonClick.bind(this))

    this.onPointerMove = this.onPointerMove.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)

    this.addEventListener('pointermove', this.onPointerMove)
    this.addEventListener('mouseleave', this.onMouseLeave)

    this.addEventListener('focusin', this.handleFocusIn.bind(this))

    this.addEventListener('keyup', this.handleEscapePress.bind(this))
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    const menuToggleEl = event.target.closest(
      '[data-header-subnav-el="menu-subnav-toggle"]',
    )

    if (!menuToggleEl) {
      return
    }

    const parentItemEl = menuToggleEl.closest('[data-header-subnav-el="item"]')
    if (!parentItemEl) return
    const menuSubnavEl = getElement('[data-header-subnav-el="menu-subnav"]', {
      context: parentItemEl,
    })

    if (!menuSubnavEl) return

    if (this.isForcedSubnav(menuSubnavEl)) {
      menuToggleEl.setAttribute('aria-expanded', 'true')
      menuSubnavEl.setAttribute('aria-hidden', 'false')
      return
    }

    const isExpanded = menuToggleEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.setAttribute('aria-expanded', 'false')
      menuSubnavEl.setAttribute('aria-hidden', 'true')
    } else {
      menuToggleEl.setAttribute('aria-expanded', 'true')
      menuSubnavEl.setAttribute('aria-hidden', 'false')
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-hidden="false"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeSubnav()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeSubnav()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeSubnav()
  }

  /**
   * @returns {void}
   */
  closeSubnav () {
    const menuSubnavToggleEls = this.querySelectorAll(
      '[data-header-subnav-el="menu-subnav-toggle"]',
    )
    const menuSubnavEls = this.querySelectorAll(
      '[data-header-subnav-el="menu-subnav"]',
    )

    menuSubnavEls.forEach((menuSubnavEl) => {
      if (this.isForcedSubnav(menuSubnavEl)) {
        menuSubnavEl.setAttribute('aria-hidden', 'false')
        return
      }

      menuSubnavEl.setAttribute('aria-hidden', 'true')
    })

    menuSubnavToggleEls.forEach((menuToggleEl) => {
      const id = menuToggleEl.dataset.id
      const panel = this.querySelector(
        `[data-header-subnav-el="menu-subnav"]#${id}`,
      )

      if (panel && this.isForcedSubnav(panel)) {
        menuToggleEl.setAttribute('aria-expanded', 'true')
        return
      }

      menuToggleEl.setAttribute('aria-expanded', 'false')
    })
  }

  onPointerMove (event) {
    const activeTrigger = event.target.closest(
      '[data-header-subnav-el="trigger"]',
    )

    if (!activeTrigger) {
      this.closeSubnav()

      return
    }

    const matchedSubnav = this.querySelector(
      `[data-header-subnav-el="menu-subnav"]#${activeTrigger.dataset.id}`,
    )

    if (matchedSubnav) {
      this.querySelectorAll('[data-header-subnav-el="menu-subnav"]').forEach(
        (menuSubnavEl) => {
          if (this.isForcedSubnav(menuSubnavEl)) {
            menuSubnavEl.setAttribute('aria-hidden', 'false')
            return
          }

          menuSubnavEl.setAttribute(
            'aria-hidden',
            menuSubnavEl !== matchedSubnav,
          )
        },
      )

      this.querySelectorAll(
        '[data-header-subnav-el="menu-subnav-toggle"]',
      ).forEach((menuToggleEl) => {
        const id = menuToggleEl.dataset.id
        const panel = this.querySelector(
          `[data-header-subnav-el="menu-subnav"]#${id}`,
        )

        if (panel && this.isForcedSubnav(panel)) {
          menuToggleEl.setAttribute('aria-expanded', 'true')
          return
        }

        menuToggleEl.setAttribute(
          'aria-expanded',
          menuToggleEl.dataset.id === matchedSubnav.id,
        )
      })
    } else {
      this.closeSubnav()
    }
  }

  onMouseLeave () {
    this.closeSubnav()
  }

  isForcedSubnav (el) {
    return el?.dataset?.subnavForced === 'true'
  }
}

if (!customElements.get('header-subnav')) {
  customElements.define('header-subnav', HeaderSubnav)
}
